import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadSecurity } from "../../actions/securityAction";

import moment from "moment";
import _ from "lodash";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import TimeRange from "@marenaud/react-timeline-range-slider";

import SecurityImage from "./components/SecurityImage";
import { useNavigate } from "react-router-dom";
import Image360 from "../../layouts/Image360";
import Toogle from "../../layouts/Toogle";
import PanZoomController from "../../layouts/PanZoomController";
import CustomTooltip from "../../layouts/CustomTooltip";
import ZoomController from "../../layouts/ZoomController";

// your forceUpdate hook
const useForceUpdate = () => {
  const [value, setValue] = useState(0);
  return () => setValue((value) => value + 1);
};

const Security = () => {
  let navigate = useNavigate();
  const forceUpdate = useForceUpdate();
  const dispatch = useDispatch();
  const [date, setDate] = useState([
    moment().subtract(5, "days"),
    moment(), // 5 days ago, current time
  ]);

  const [selectedTime, setSelectedTime] = useState([
    moment().subtract(5, "days"),
    moment(), // 5 days ago, current time
  ]);

  const [maxDate, setMaxDate] = useState(moment().startOf("day"));
  const [minDate, setMinDate] = useState(moment().subtract(5, "days"));

  const [error, setError] = useState(false);
  const [checked, setChecked] = useState(true);

  const [room, setRoom] = useState(null);
  const [tooltipRoom, setTooltipRoom] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [showDetail, setShowDetail] = useState(false);

  const [image, setImage] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);

  const dark = useSelector((state) => state.dark.data);
  const security = useSelector((state) => state.security.data);
  const dashboard = useSelector((state) => state.dashboard.data);
  const building = useSelector((state) => state.building.data);
  const floor = useSelector((state) => state.floor.data);
  const userInfo = useSelector((state) => state.auth.user);
  const [filteredSecurity, setFilteredSecurity] = useState(null);
  const panZoomRef = useRef(null);

  const handleZoomIn = () => {
    if (panZoomRef.current) {
      panZoomRef.current.zoomIn();
    }
  };

  const handleZoomOut = () => {
    if (panZoomRef.current) {
      panZoomRef.current.zoomOut();
    }
  };

  const handleReset = () => {
    if (panZoomRef.current) {
      panZoomRef.current.reset();
    }
  };

  useEffect(() => {
    if (security === undefined && userInfo) {
      dispatch(
        loadSecurity(
          `between=${date[0]}--${date[1]}&params=FileName&user=${
            userInfo?.username
          }${building ? `&building=${building.id}` : ""}${
            floor ? `&floor=${floor.id}` : ""
          }${room ? `&room=${room.id}` : ""}`
        )
      );
    }

    if (!dashboard || !userInfo) {
      return navigate("/");
    }
  }, [loadSecurity, dispatch, userInfo]);

  useEffect(() => {
    if (room) {
      dispatch(
        loadSecurity(
          `between=${date[0]}--${date[1]}&params=FileName&user=${
            userInfo?.username
          }${building ? `&building=${building.id}` : ""}${
            floor ? `&floor=${floor.id}` : ""
          }&roomSelected=true${
            room !== null && room !== undefined ? `&room=${room.id}` : ""
          }`
        )
      );
    } else {
      dispatch(
        loadSecurity(
          `between=${date[0]}--${date[1]}&params=FileName&user=${
            userInfo?.username
          }${building ? `&building=${building.id}` : ""}${
            floor ? `&floor=${floor.id}` : ""
          }&roomSelected=false${
            room !== null && room !== undefined ? `&room=${room.id}` : ""
          }`
        )
      );
    }
  }, [room]);

  useEffect(() => {
    if (security && !filteredSecurity) {
      setFilteredSecurity(security);
    }
    if (!security && filteredSecurity) {
      setFilteredSecurity(security);
    }
  }, [security, filteredSecurity]);

  useEffect(() => {
    if (security) {
      setFilteredSecurity({
        FileName: checked
          ? _.orderBy(security?.FileName, ["enqueuedTime_Stamp"], ["desc"])
          : _.sortBy(security?.FileName, ["enqueuedTime_Stamp"]),
      });
    }
  }, [checked, security]);

  // Effect to reset the data based on selection of the date time slider
  useEffect(() => {
    if (security) {
      setDate([
        moment(security.dateTimeRange.min),
        moment(security.dateTimeRange.max),
      ]);
      setSelectedTime([
        moment(security.dateTimeRange.min),
        moment(security.dateTimeRange.max),
      ]);
      setMinDate(moment(security.dateTimeRange.validMin));
      setMaxDate(moment(security.dateTimeRange.validMax));
    }
  }, [security]);

  return (
    <div
      className="dashboard h-100 w-100  overflow-hidden"
      style={{
        backgroundImage: `url('./images/building${dark ? "" : "-Light"}.png')`,
      }}
    >
      <div className="container-fluid py-4  h-100 w-100">
        <div className="row w-100 h-66 flex-column flex-lg-row m-0 ">
          <div
            className="col col-lg-6 h-100 d-flex flex-column justify-content-center"
            style={{ position: "relative" }}
          >
            <CustomTooltip showDetail={showDetail} tooltipRoom={tooltipRoom} />
           
            {/* Zoom Controller Heatmap */}
            <div className="w-100 d-flex align-items-center justify-content-center mt-2">
              <ZoomController
                zoomIn={handleZoomIn}
                zoomOut={handleZoomOut}
                reset={handleReset}
              />
            </div>
            <div className="w-100 h-100 text-center mb-lg-0 mb-5 d-flex flex-column align-items-center justify-content-between overflow-hidden">
              {floor && (
                <PanZoomController panZoomRef={panZoomRef}>
                  <SecurityImage
                    building={building}
                    floor={floor}
                    setRoom={setRoom}
                    setSelectedTime={setSelectedTime}
                    date={date}
                    setTooltipRoom={setTooltipRoom}
                    setTooltipPosition={setTooltipPosition}
                    showDetail={showDetail}
                    setShowDetail={setShowDetail}
                  />
                </PanZoomController>
              )}
            </div>
          </div>
          <div className="col h-100 d-flex flex-column  px-2 px-lg-5">
            <div className="w-100 align-items-center d-flex justify-content-between h-25 flex-column flex-lg-row ">
              <div className="h-25 d-flex align-items-center justify-content-center w-100 mb-5 mb-lg-0">
                <div className="w-100 d-flex flex-column align-items-center justify-content-center">
                  <div
                    className={`w-100 text-center ${dark ? "text-white" : ""}`}
                  >
                    <span>Selected Interval: </span>

                    <span>{moment(selectedTime[0]).format("HH:mm Do")}</span>
                    <span className="mx-2">-</span>
                    <span>{moment(selectedTime[1]).format("HH:mm Do")}</span>
                  </div>
                  <TimeRange
                    onUpdateCallback={(e) => setError(e.error)}
                    error={error}
                    ticksNumber={10}
                    className="text-white"
                    selectedInterval={selectedTime}
                    timelineInterval={date}
                    onChangeCallback={(selectedInterval) => {
                      if (filteredSecurity) {
                        const localToUTCFrom = moment(
                          selectedInterval[0]
                        ).format();
                        const localToUTCTo = moment(
                          selectedInterval[1]
                        ).format();

                        let filter = {};

                        for (let key in security) {
                          if (security[key].length === 0) filter[key] = [];
                          for (let i = 0; i < security[key].length; i++) {
                            if (filter[key] === undefined) filter[key] = [];
                            let convertTimeStamp = moment(
                              security[key][i].enqueuedTime_Stamp
                            )
                              .local()
                              .format();

                            if (
                              convertTimeStamp >= localToUTCFrom &&
                              convertTimeStamp <= localToUTCTo
                            ) {
                              filter[key].push(security[key][i]);
                            }
                          }
                        }
                        setFilteredSecurity(filter);
                      }
                      setSelectedTime(selectedInterval);
                    }}
                    formatTick={(ms) => {
                      return moment(ms).format("HH:mm Do MMM");
                    }}
                  />
                </div>
              </div>
              <div className="">
                <DateRangePicker
                  clearIcon={null}
                  calendarIcon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      stroke={dark ? "white" : "black"}
                      stroke-width="2"
                      class="react-daterange-picker__calendar-button__icon react-daterange-picker__button__icon"
                    >
                      <rect
                        fill="none"
                        height="15"
                        width="15"
                        x="2"
                        y="2"
                      ></rect>
                      <line x1="6" x2="6" y1="0" y2="4"></line>
                      <line x1="13" x2="13" y1="0" y2="4"></line>
                    </svg>
                  }
                  onInvalidChange={() =>
                    alert(
                      "The date range picked is out of the project range. Please select the valid date range"
                    )
                  }
                  minDate={minDate.toDate()}
                  maxDate={maxDate.toDate()}
                  onChange={(e) => {
                    console.log(e);
                    setDate(e);
                    setSelectedTime(e);
                    dispatch(
                      loadSecurity(
                        `between=${e[0]}--${e[1]}&params=FileName&user=${
                          userInfo?.username
                        }${building ? `&building=${building.id}` : ""}${
                          floor ? `&floor=${floor.id}` : ""
                        }${
                          room ? `&room=${room.id}` : ""
                        }&timeRangeSelected=true`
                      )
                    );
                    setChecked(true);
                    setFilteredSecurity(security);
                  }}
                  value={date}
                />
              </div>
            </div>
            <div className="h-66">
              {filteredSecurity && filteredSecurity.FileName?.length > 0 ? (
                <div className="h-100 w-100 mt-4 shadow  p-2 dashboard-health">
                  <div
                    className={isModalVisible ? "modal show" : "modal"}
                    tabIndex="-1"
                    id="staticBackdrop"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog bg-transparent shadow-none modal-xl ">
                      <div className="modal-content bg-transparent shadow-none border-0">
                        <div className="modal-header border-0">
                          <button
                            type="button"
                            className="btn-close btn-close-white"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setIsModalVisible(false)}
                          ></button>
                        </div>
                        {filteredSecurity.FileName && (
                          <div className="modal-body bg-transparent">
                            {filteredSecurity.FileName.length > 0 && (
                              <Image360 image={image} />
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="">
                    <p className="dashboard-health-title text-main m-0 d-flex justify-content-between ">
                      <div className="dashboard-health-title">360 Images</div>

                      {/* Sort option */}
                      <div className="d-flex align-items-center justify-content-between gap-3">
                        <div className="" style={{ fontSize: "17px" }}>
                          Sort By:{" "}
                        </div>
                        <div className="" style={{ width: "150px" }}>
                          <Toogle
                            checked={checked}
                            setChecked={setChecked}
                            labels={["Oldest", "Newest"]}
                          />
                        </div>
                      </div>
                    </p>
                  </div>
                  <div className="dashboard-health-body flex-fill mt-3 overflow-auto h-75">
                    <div className="d-flex h-100 w-100 flex-wrap">
                      <>
                        {filteredSecurity.FileName?.map((file, i) => (
                          <div className="w-25 p-2">
                            <h6>Room {file.RoomID}</h6>
                            {/* <LazyLoadImage
                                alt={file.FileName}
                                effect='blur'
                                data-bs-toggle='modal'
                                data-bs-target='#staticBackdrop'
                                width='100%'
                                className='shadow cursor-pointer'
                                onClick={() => {
                                  setImage(file.FileName);
                                }}
                                src={file.FileName}
                              /> */}
                            <img
                              src={file.FileName}
                              alt=""
                              data-bs-toggle="modal"
                              data-bs-target="#staticBackdrop"
                              width="100%"
                              className="shadow cursor-pointer"
                              onClick={() => {
                                setImage(file.FileName);
                                setIsModalVisible(true);
                              }}
                            />
                            <span>
                              {moment(file.enqueuedTime_Stamp).format(
                                "MM-DD-YYYY HH:mm:ss"
                              )}
                            </span>
                          </div>
                        ))}
                      </>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="h-75 d-flex align-items-center justify-content-center w-100">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="row gy-4 gy-lg-0 w-100 h-33 px-4 pt-2 flex-column flex-lg-row">
          <div className="col  h-100">
            <img
              src={`./images/inspection.png`}
              alt=""
              className="h-100 w-100"
            />
          </div>
          <div className="col  h-100">
            <img src={`./images/360.png`} alt="" className="h-100 w-100" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Security;
